<template>
  <WizardLayout v-if="enabled">
    <template #title>Need help around the house?</template>

    <div class="d-flex flex-column">
      <v-card class="ma-2">
        <v-card-text class="black--text">

          <SearchBar />

          <div v-if="frequent.length > 0" >
            <div class="mt-6 font-weight-bold" style="font-size: 20px;">
              Choose from popular services
            </div>

            <div class="d-flex flex-row mt-3" style="overflow-x: auto; column-gap: 12px">
              <ServiceButton 
                v-for="service in frequent" 
                :service="service" 
                :key="service.service_id"
                @click="clickService(service.service_id)"
              />
            </div>
          </div>

          <div class="font-weight-bold mt-5" style="font-size: 20px;">
            Browse by category
          </div>

          <div class="d-flex flex-row mt-3 flex-wrap" style="gap: 12px">
            <v-btn
              v-for="(category, i) in categories" 
              :key="`cb-${ i }`"
              color="primary" small
              class="rounded-lg"
              :to="{ name: 'wizard/service', query: { s: category } }"
            >
              {{ category }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </WizardLayout>

  <EmptyLayout v-else>
    <div 
      class="d-flex flex-column justify-center text-center align-center white"
      style="height: 100%"
    >
      <v-icon size="80px" color="yellow darken-2">mdi-alert-circle-outline</v-icon>
      <div class="mt-2 font-weight-bold">Oops! Something went wrong</div>
      <div class="mx-12 mt-4">
        This feature is not setup.  Please contact {{ account_name }}
        so they can make a referral for you.
      </div>
    </div>
  </EmptyLayout>
</template>

<script>

import { EmptyLayout, WizardLayout } from '@/layouts'
import SearchBar from '../../SearchBar'
import ServiceButton from '../../ServiceButton'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'QRCategoryView',

  data: () => ({
    loading: false,
    enabled: true,
    account_name: '',

    search: '',
  }),

  components: { EmptyLayout, SearchBar, ServiceButton, WizardLayout },

  computed: {
    ...mapGetters('qr', ['categories', 'frequent']),
  },

  methods: {
    ...mapActions('qr', ['isEnabled', 'loadCategories', 'loadFrequent', 'setService']),

    clickService(service_id) {
      this.setService({ service_id })
      this.$router.replace({ name: 'wizard/property' })
    },
  },

  async created() {
    this.loading = true
    
    const frequentDone = this.loadFrequent()
    const categoriesDone = this.loadCategories()

    const result = await this.isEnabled()
    if (!result.ok) {
      this.enabled = false
      this.account_name = result.account_name || 'the business that directed you here'
    }

    await categoriesDone
    await frequentDone

    this.loading = false
  },
}
</script>

<style scoped>
  div.overlay {
    color: white;
    position: absolute;
    top: 50%;
    left: 50%;
    font-size: 40px;
    font-weight: bold;
    line-height: 1.3;
    transform: translate(-50%, -50%);
    text-align: center;
    width: 85%;
  }
</style>